module.exports = __webpack_public_path__ + "img/2-hublot-block-2.8a64788c.png";